import {isClipboardCopyAllowed} from '../../utils/isClipboardCopyAllowed';
import type {EagGridState} from '../createEagGridStore';

export const selectCanCopyColumn = (state: EagGridState, columnKey: string): boolean =>
  isClipboardCopyAllowed(state, [columnKey]);
